import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, livingEnemies, enemySide, getRuntimes, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'backline_hit',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1.3;
        const back = livingEnemies(state, source.side).filter(e => e.slot >= 2);
        if (back.length === 0)
            return;
        const target = back.reduce((m, e) => e.runtime.hp < m.runtime.hp ? e : m);
        const sourceRt = getRuntimes(state, source.side)[source.slot];
        const dmg = computeDamage(effectiveAtk(sourceRt) * mult, effectiveDef(target.runtime));
        applyDamage(state, source, { side: enemySide(source.side), slot: target.slot }, dmg, false, rng);
    }
});
